export const CURRENCY_DEFAULT_ROUNDING = 2;
